import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';
import { apiClient } from '../apiClient';

export interface CommandExecutionRequest extends Record<string, unknown> {
  command: string;
  args: string[];
  user_id: string;
  thread_id?: string;
}

export interface CommandExecutionResponse {
  success: boolean;
  result?: any;
  error?: string;
  execution_time: number;
  command: string;
  args: string[];
}

export interface AvailableCommand {
  name: string;
  description?: string;
  usage: string;
  examples?: string[];
  category: string;
  permissions?: string[];
}

export interface AvailableCommandsResponse {
  commands: AvailableCommand[];
  total: number;
}

export class CommandExecutionService extends BaseService {
  /**
   * Execute a command on the backend with optional thread context
   */
  static async executeCommand(
    command: string,
    args: string[],
    userId: string,
    threadId?: string
  ): Promise<CommandExecutionResponse> {
    const requestData: CommandExecutionRequest = {
      command,
      args,
      user_id: userId,
      ...(threadId && { thread_id: threadId })
    };

    return this.post<CommandExecutionResponse>(
      '/commands/execute',
      requestData
    );
  }

  /**
   * Get all available commands formatted for LLM consumption
   */
  static async getAvailableCommands(): Promise<AvailableCommandsResponse> {
    const response = await apiClient.get<AvailableCommandsResponse>('/commands/available');
    return response.data;
  }
}
